module.exports = __webpack_public_path__ + "static/media/banner_convenio_c360.27c8927c.png";